import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { GasBreadcrumb } from './gas-breadcrumbs.interface';

@Component({
  selector: 'gas-breadcrumbs',
  templateUrl: './gas-breadcrumbs.component.html',
  styleUrls: ['./gas-breadcrumbs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GasBreadcrumbsComponent {
  @Input()
  public breadcrumb: GasBreadcrumb[] = [];
}
